import { ReactComponent as PowderedSugarToppingButton } from './powdered_sugar_topping_button.svg'
import { ReactComponent as ChocolateSprinklesToppingButton } from './chocolate_sprinkles_topping_button.svg'
import { ReactComponent as StrawberrySprinklesToppingButton } from './strawberry_sprinkles_topping_button.svg'
import { ReactComponent as RainbowSprinklesToppingButton } from './rainbow_sprinkles_topping_button.svg'
import { ReactComponent as HeartCandyToppingButton } from './heart_candy_topping_button.svg'
import { ReactComponent as CerealToppingButton } from './cereal_topping_button.svg'

const DonutToppingButtons = {
  PowderedSugarToppingButton,
  ChocolateSprinklesToppingButton,
  StrawberrySprinklesToppingButton,
  RainbowSprinklesToppingButton,
  HeartCandyToppingButton,
  CerealToppingButton,
}

export default DonutToppingButtons
